<template>
  <b-sidebar
    id="add-new-grupousuario-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="showAddUserSidebar($event)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add New User
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Username -->
          <validation-provider
            #default="validationContext"
            name="Nome"
            rules="required"
          >
            <b-form-group
              label="Nome"
              label-for="username"
            >
              <b-form-input
                id="grupousuario"
                v-model="tabelaPreco.descricao"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] ? 'Nome do grupo é obrigatório' : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-form-group>
            <h5>Data Início da Validade</h5>
            <flat-pickr
                v-model="tabelaPreco.data_inicio_validade"
                class="form-control"
                :config="{ dateFormat: 'd/m/Y'}"
            />
          </b-form-group>

          <b-form-group>
            <h5>Data Término da Validade</h5>
            <flat-pickr
                v-model="tabelaPreco.data_termino_validade"
                class="form-control"
                :config="{ dateFormat: 'd/m/Y'}"
            />
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ tabelaPreco.id === null ? 'Adicionar' : 'Atualizar' }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>

  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { computed } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    flatPickr,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-usuarios-sidebar-active',
  },
  props: {
    blankData: {
      type: Object,
      required: true,
    },
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    }
  },
  methods: {
    showAddUserSidebar(e) {
      this.$emit('input', e)
    },
  },
  setup(props, { emit }) {
    const tabelaPreco = computed({
      get: () => {
        if (props.blankData) {
          return props.blankData
        }
        return JSON.parse(JSON.stringify(props.blankData))
      },
      set: val => {
        emit('update:blankData', val)
      },
    })
    const resettabelaPreco = () => {
      tabelaPreco.value = JSON.parse(JSON.stringify(tabelaPreco.value))
    }

    const formataData = data => (data ? data.split('T')[0] : null)

    const onSubmit = () => {
      tabelaPreco.value.data_inicio_validade = formataData(tabelaPreco.value.data_inicio_validade)
      tabelaPreco.value.data_termino_validade = formataData(tabelaPreco.value.data_termino_validade)
      if (tabelaPreco.value.id === null) {
        store.dispatch('appTabelaPreco/addTabelaPreco', {
          ...tabelaPreco.value,
        })
          .then(() => {
            emit('refetch-data')
            emit('input', false)
          })
        return
      }

      store.dispatch('appTabelaPreco/updatedTabelaPreco', {
        ...tabelaPreco.value,
      })
        .then(() => {
          emit('refetch-data')
          emit('input', false)
        })
    }

    const {
      fetchGrupos,
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resettabelaPreco)

    return {
      fetchGrupos,
      tabelaPreco,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-grupousuario-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
